import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["fontSize"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from "react";
import { Radio as MuiRadio } from "@mui/material";
import { RaiseColors, makeStyles } from "componentLibrary";
import { jsx as _jsx } from "react/jsx-runtime";
var Radio = function Radio(_ref) {
  var _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 16 : _ref$fontSize,
    muiRadioProps = _objectWithoutProperties(_ref, _excluded);
  var classes = makeStyles(function (theme) {
    return {
      checkedIcon: {
        width: 24,
        height: 24,
        backgroundColor: muiRadioProps.disabled ? RaiseColors.jllNeutral400 : RaiseColors.bahama1200,
        border: "1px solid ".concat(muiRadioProps.disabled ? RaiseColors.jllNeutral400 : RaiseColors.bahama1200),
        borderRadius: "50%",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        "&:before": {
          content: '""',
          width: 12,
          height: 12,
          backgroundColor: muiRadioProps.disabled ? RaiseColors.neutral200 : RaiseColors.white,
          borderRadius: "50%",
          position: "absolute"
        }
      },
      icon: {
        width: 24,
        height: 24,
        backgroundColor: RaiseColors.white,
        border: "1px solid ".concat(muiRadioProps.disabled ? RaiseColors.jllNeutral400 : RaiseColors.glacier400),
        borderRadius: "50%",
        display: "inline-block"
      }
    };
  })();
  return /*#__PURE__*/_jsx(MuiRadio, _objectSpread({
    "data-testid": "radio-test",
    checkedIcon: /*#__PURE__*/_jsx("span", {
      className: classes.checkedIcon
    }),
    icon: /*#__PURE__*/_jsx("span", {
      className: classes.icon
    }),
    disableRipple: true
  }, muiRadioProps));
};
export default Radio;